import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  constructor(private http: HttpClient) {}

  createRole(data: any): Observable<any> {
    return this.http.post(`${environment.authUrl}/role`, data);
  }

  getRoles(
    searchTerm: string = '',
    limit: number,
    offset: number
  ): Observable<any> {
    return this.http.get(`${environment.authUrl}/role`, {
      params: { searchTerm, limit, offset },
    });
  }

  updateRole(id: string, data: any): Observable<any> {
    return this.http.patch(`${environment.authUrl}/role/${id}`, data);
  }

  deleteRole(id: number): Observable<any> {
    return this.http.delete(`${environment.authUrl}/role/${id}`);
  }
}
